import { useEffect, useRef } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  let sid = sessionStorage.getItem("pubpro_sid");
  if (!sid) {
    sid = Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem("pubpro_sid", sid);
  }
  return sid;
}

export function useVisitorTracking() {
  const intervalRef = useRef(null);

  useEffect(() => {
    const sessionId = getSessionId();
    const referrer = document.referrer || null;

    const sendHeartbeat = () => {
      const page = window.location.pathname;
      fetch(`${API}/track/heartbeat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId, page, referrer }),
      }).catch(() => {});
    };

    sendHeartbeat();
    intervalRef.current = setInterval(sendHeartbeat, 30000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
}
